import React, { Component } from 'react';
import ReactTestUtils
	from 'react-dom/test-utils';
import $
	from 'jquery';
import update
	from 'immutability-helper';
import Main
	from './includes/Main';
import AccesibilityActions
	from './includes/AccesibilityActions';
import { eventClickPauActions } from './assets/js/MenuPauPrincipal';
import './App.css';
import { instanceOf } from 'prop-types';
import {
	withCookies,
	Cookies
} from 'react-cookie';
import { pictosPanelHeader } from './assets/img/panel';
import { isLocalhost } from './constants/isLocalHost';

class App extends Component {

	static propTypes = {
		cookies : instanceOf( Cookies ).isRequired
	};

	constructor( props ) {

		super( props );

		global.LicenseState = null;

		const { cookies } = props;

		let settings = cookies.get( "settings" ) || null;
		let zoom_pau = 100;

		if ( settings ) {
			zoom_pau = settings.zoom_pau.value;
		}

		this.state = {
			zoom_pau,
			globals     : null,
			getLicense  : null,
			licenseData : null,
		};

		let $pauMainAcces = $( "#pauMainAcces" ),
			license       = $pauMainAcces.attr( "data-license" ),
			siteurl       = $pauMainAcces.attr( 'data-siteurl' ),
			urlBase       = `${siteurl}/wp-json/pau/v1/`,
			urlSettings   = `${urlBase}config`,
			urlHotspots   = `${urlBase}hotspots`,
			urlglobal     = `${urlBase}global`,
			urlApi        = `https://clientes.estudioinclusivo.com/api/eu/${license}`;

		this.fetchUrls = {
			urlSettings,
			urlHotspots,
			urlglobal,
			urlApi
		};

		// this.apiWorkSuite();

		AccesibilityActions.zoomPanel( zoom_pau );

	}

	apiWorkSuite() {

		fetch( this.fetchUrls.urlApi )
			.then( res => {
				return res.json();
			} )
			.then( data => {

				const { status } = data;

				global.licenseState = status;

				this.setState( update( this.state, {
					getLicense  : { $set : true },
					licenseData : { $set : data }
				} ) );

			} )
			.catch( error => console.log( error ) );

	}

	componentWillMount() {

		this.getGlobal();

	}

	getGlobal() {

		fetch( this.fetchUrls.urlglobal )
			.then( res => {
				return res.json();
			} )
			.then( data => {

				this.setState( update( this.state, {
					globals : { $set : data }
				} ) );

			} )
			.catch( error => console.log( error ) );

	}

	zoomMasMenos( type ) {

		const { cookies } = this.props;
		const settings = cookies.get( "settings" );
		const { zoom_pau } = settings;

		var value = zoom_pau.value;

		if ( type === "mas" ) {
			if ( zoom_pau.value !== 200 ) value += 10;
		} else if ( type === "menos" ) {
			if ( zoom_pau.value !== 70 ) value -= 10;
		}

		let zoomVal = {
			value : { $set : value }
		};

		let dzoom = document.getElementById( "pauPanelZoomPerc" );
		dzoom.childNodes[ 0 ].textContent = value;
		AccesibilityActions.zoomPanel( value );

		cookies.remove( "settings", { path : "/" } );
		cookies.set( "settings", update( settings, {
			zoom_pau : zoomVal
		} ), { path : "/" } );

		this.setState( update( this.state, {
			zoom_pau : { $set : value }
		} ) );

	}

	btnReset() {

		const { cookies } = this.props;
		const settings = cookies.get( "settings" );

		if ( settings.perfil_defecto.value !== "default" ) {

			let $profileDefecto = document.getElementById( "pauPerfilPorDefecto" );

			ReactTestUtils.Simulate.click( $profileDefecto );

		}

	}

	render() {

		const { globals, getLicense, licenseData } = this.state;

		return [
			<div
				key="pauContPanel"
				id="pauContPanel"
				data-value="1"></div>,
			<div
				key="pauContMain"
				id="pauContMain"
				data-value="1"></div>,
			<div
				key="iconPauAcces"
				className="iconPauAcces">
				{globals ?
					<img
						className="iconEstInc"
						src={`${pictosPanelHeader( globals.pau_PluginDirUrl ).icoPrin}`}
						data-key="iconPauAcces"
						alt="Icono de menú"
						onClick={eventClickPauActions}/> : ""}
			</div>,
			<div
				id="pauContenedor"
				key="pauMain"
				style={{ backgroundColor : "#efefef" }}>
				{/*Cabecera del panel*/}
				<div
					id="pauHeaderAcces">
					<div
						id="pauIconsHeader">
                        <span
							className="pauActionHeader">
                            {globals ?
								<img
									onClick={this.zoomMasMenos.bind( this, "menos" )}
									src={`${pictosPanelHeader( globals.pau_PluginDirUrl ).menos}`}
									alt="Botón para disminuir el tamaño del panel"/> : ""}
                        </span>
						<span
							id="pauDisplayZoom"
							className="pauActionHeader">
                            {this.state.zoom_pau}%
                        </span>
						<span
							className="pauActionHeader">
                            {globals ?
								<img
									onClick={this.zoomMasMenos.bind( this, "mas" )}
									src={`${pictosPanelHeader( globals.pau_PluginDirUrl ).mas}`}
									alt="Botón para aumentar el tamaño del panel"/> : ""}
                        </span>
						<span
							className="pauActionHeader">
                            {globals ?
								<img
									onClick={this.btnReset.bind( this )}
									src={`${pictosPanelHeader( globals.pau_PluginDirUrl ).reset}`}
									alt="Botón para resetear las opciones"/> : ""}
                        </span>
					</div>
				</div>
				{globals ?
					<Main
						key="pauMain"
						// licenseData={licenseData}
						globals={globals}
						fetchUrls={this.fetchUrls}/> : ""}
			</div>
		];
	}

}

export default withCookies( App );



// WEBPACK FOOTER //
// ./src/App.js